// src/pages/Campanhas/DetalhesCampanhaPage.js

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Typography, Button, Paper, Grid, CircularProgress, Box, Chip,
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { obterCampanha, excluirCampanha } from '../../services/campanhaService';
import { useAuth } from '../../hooks/useAuth';
import PageHeader from '../../components/Common/PageHeader';


const DetalhesCampanhaPage = () => {
  const [campanha, setCampanha] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth(); // Obter o usuário autenticado

  useEffect(() => {
    const fetchCampanha = async () => {
      try {
        setLoading(true);
        const data = await obterCampanha(id);
        setCampanha(data);
      } catch (error) {
        console.error('Erro ao buscar detalhes da campanha:', error);
        setError(
          'Não foi possível carregar os detalhes da campanha. Por favor, tente novamente.'
        );
      } finally {
        setLoading(false);
      }
    };

    fetchCampanha();
  }, [id]);

  const handleExcluir = async () => {
    if (window.confirm('Tem certeza que deseja excluir esta campanha?')) {
      try {
        setLoading(true);
        await excluirCampanha(id);
        navigate('/campanhas');
      } catch (error) {
        console.error('Erro ao excluir campanha:', error);
        setError(
          'Ocorreu um erro ao excluir a campanha. Por favor, tente novamente.'
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const handlePreInscricao = () => {
    navigate(`/pre-inscricoes/criar?campanhaId=${id}`);
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          height: '50vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" sx={{ mt: 2 }}>
        {error}
      </Typography>
    );
  }

  if (!campanha) {
    return (
      <Typography sx={{ mt: 2 }}>Campanha não encontrada.</Typography>
    );
  }

  const isAdmin = user.tipo === 'admin' || user.tipo === 'instituicao';

  return (
    <Box sx={{ p: 3 }}>
      <PageHeader
        title={campanha.nome}
        subtitle={campanha.instituicao?.nome}
        backTo="/campanhas"
        breadcrumbs={[{ label: 'Campanhas', to: '/campanhas' }, { label: campanha.nome }]}
        actions={
          <>
            {user.tipo === 'estudante' && (
              <Button variant="contained" size="small" onClick={handlePreInscricao}>
                Realizar Pré-inscrição
              </Button>
            )}
            {isAdmin && (
              <>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<EditIcon />}
                  onClick={() => navigate(`/campanhas/editar/${id}`)}
                >
                  Editar
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  startIcon={<DeleteIcon />}
                  onClick={handleExcluir}
                >
                  Excluir
                </Button>
              </>
            )}
          </>
        }
      />
      <Paper sx={{ p: 3, borderRadius: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography gutterBottom>
              <strong>Instituição:</strong>{' '}
              {campanha.instituicao?.nome || 'Não especificada'}
            </Typography>
            <Typography gutterBottom>
              <strong>Data de Início:</strong>{' '}
              {new Date(campanha.dataInicio).toLocaleDateString('pt-MZ')}
            </Typography>
            <Typography gutterBottom>
              <strong>Data de Fim:</strong>{' '}
              {new Date(campanha.dataFim).toLocaleDateString('pt-MZ')}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography gutterBottom>
              <strong>Status:</strong>{' '}
              <Chip label={campanha.status} size="small" color={campanha.status === 'ativa' ? 'success' : 'default'} />
            </Typography>
            <Typography gutterBottom>
              <strong>Pré-Inscrições:</strong> {campanha.preInscricoes?.length || 0}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography gutterBottom>
              <strong>Descrição:</strong> {campanha.descricao}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              <strong>Mensagem de Confirmação:</strong>{' '}
              {campanha.mensagemConfirmacaoPersonalizada || 'Usando mensagem padrão da instituição'}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default DetalhesCampanhaPage;